import React from 'react'
import "./section6.css"
import study from "../../../assets/home/blogsimg.png"
import Calander from "../../../assets/home/calender.png"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import { NavLink } from 'react-router-dom';
const Section6 = () => {
    const studyPrograms = [
        {
            id: 1,
            university: 'Oxford University',
            degree: 'MSc in Advanced Computer Science',
            duration: '12 Months',
            location: 'England',
            imgSrc: study,
        },
        {
            id: 2,
            university: 'Harvard University',
            degree: 'MSc in Data Science',
            duration: '24 Months',
            location: 'USA',
            imgSrc: study,
        },
        {
            id: 3,
            university: 'MIT',
            degree: 'MSc in AI and Robotics',
            duration: '18 Months',
            location: 'USA',
            imgSrc: study,
        },
        {
            id: 4,
            university: 'Cambridge University',
            degree: 'MSc in Advanced Computer Science',
            duration: '12 Months',
            location: 'UK',
            imgSrc: study,
        }
    ];
    return (
        <div className='section6'>
            <div className='tophead6'>
                <div className='topleft'>
                    <h1>Discover Insights from <span>Study Abroad Blogs</span></h1>
                    <p>Get clarity on your most asked questions by exploring our blogs</p>
                </div>
            </div>
            <div className='studyprogram'>
                <div className='swiper-button-prev arrow-left6'><i class="fa-solid fa-angle-left"></i></div>
                <div className='swiper-button-next custom-arrow-right arrow-right6'><i class="fa-solid fa-chevron-right"></i></div>
                <Swiper
                    grabCursor={true}
                    centeredSlides={true}
                    modules={[ Navigation]}
                    loop={true}
                    className='mySwipersection6'
                    spaceBetween={40}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    breakpoints={{
                        320: {   // For phones
                            slidesPerView: 1,
                     
                        },
                        768: {   // For tablets
                            slidesPerView: 2,
                          
                        },
                        1024: {  // For laptops and larger screens
                            slidesPerView: 3,
                        },
                    }}
                >
                    {studyPrograms.map(program => (
                        <SwiperSlide key={program.id} className='studybox6slider'>
                            <div className='newstudybox'>
                                <img src={program.imgSrc} alt='study' />
                                <p className='msc'>{program.degree}</p>
                                <div className='divkeander'>
                                    <div className='date'>
                                        <img src={Calander} alt='calander'/>
                                        <p>23 Sep'24</p>
                                    </div>
                                    <NavLink to="/blog" className='more'>...Read More</NavLink>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}

                </Swiper>
            </div>
        </div>
    )
}

export default Section6
